import { render, staticRenderFns } from "./AddEditWorkerPopup.vue?vue&type=template&id=3459c152"
import script from "./AddEditWorkerPopup.vue?vue&type=script&lang=ts"
export * from "./AddEditWorkerPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddEditWorkerPopup.vue?vue&type=style&index=0&id=3459c152&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports